import {Box} from '@indoqa/style-system'
import {IStyle} from 'fela'
import * as React from 'react'
import {AdminLayoutContext, AdminLayoutContextValue} from './AdminLayoutContext'

export const AdminLayoutFooter: React.FC = ({children}) => {
  const {dimensions} = React.useContext<AdminLayoutContextValue>(AdminLayoutContext)
  const footerStyle: IStyle = {
    print: {
      display: 'none',
    },
  }
  return (
    <Box fullWidth height={dimensions.footerHeight} style={footerStyle}>
      {children}
    </Box>
  )
}
